import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { FormControl, Select, MenuItem } from 'material-ui';

const tabIsActive = (match, location, type) => {
  const params = new URLSearchParams(location.search);
  const listingType = params.get('listingType');

  if (match && !listingType) {
    return true;
  } else if (listingType === type) {
    return true;
  }
  return false;
};

const getFilterValue = (location) => {
  const params = new URLSearchParams(location.search);
  let listingType = params.get('listingType');
  if (!listingType) {
    listingType = location.pathname
      .replace('/dashboard/', '')
      .replace('-', '_')
      .toUpperCase();
  }
  return listingType;
};

const createFilterOptions = (tenant, isAuthenticated) => {
  const availableListingTypes = get(tenant, 'availableListingTypes', []);
  const baseUrl = !isAuthenticated ? '/' : '/dashboard/all-offers';
  const newFilterOptions = {};

  if (availableListingTypes.length > 1) {
    newFilterOptions.ALL_OFFERS = {
      to: baseUrl,
      title: 'All Offers',
    };
  }

  if (isAuthenticated) {
    newFilterOptions.MY_OFFERS = {
      to: '/dashboard/my-offers',
      title: 'My Offers',
    };
  }

  return newFilterOptions;
};

const FilterOption = ({ filterOptions, option }) => (
  <NavLink
    key={option}
    className='_2nd-nav-link w-nav-link'
    activeClassName='active-link'
    to={filterOptions[option].to}
    isActive={(match, location) => tabIsActive(match, location, option)}
  >
    {filterOptions[option].title}
  </NavLink>
);

FilterOption.propTypes = {
  filterOptions: PropTypes.object.isRequired,
  option: PropTypes.string.isRequired,
};

class OfferNav extends React.Component {
  constructor(props) {
    super(props);
    const listingType = getFilterValue(props.location);

    this.state = {
      listingType: listingType || 'ALL_OFFERS',
    };
  }

  onChange = (e) => {
    const listingType = e.target.value;
    const baseUrl = !this.props.isAuthenticated ? '/' : '/dashboard/all-offers';
    let newUrl = `${baseUrl}?listingType=${listingType}`;

    if (listingType === 'MY_OFFERS') {
      newUrl = '/dashboard/my-offers';
    } else if (listingType === 'MY_INVESTMENTS') {
      newUrl = '/dashboard/my-investments';
    }

    this.setState({ listingType });
    window.location.href = newUrl;
  };

  render() {
    const { tenant } = this.context;
    const { listingType } = this.state;
    const { isAuthenticated } = this.props;
    const filterOptions = createFilterOptions(tenant, isAuthenticated);

    return (
      <div className='nav-menu-4 w-nav-menu'>
        {Object.keys(filterOptions).map((option) => (
          <FilterOption
            key={option}
            filterOptions={filterOptions}
            option={option}
          />
        ))}
        <FormControl>
          <Select
            value={listingType}
            name='filters'
            onChange={this.onChange}
            className='filters-small-screen'
          >
            {Object.keys(filterOptions).map((option) => (
              <MenuItem key={option} value={option}>
                {filterOptions[option].title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
  }
}

OfferNav.contextTypes = {
  tenant: PropTypes.object,
};

OfferNav.propTypes = {
  location: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ session }) => ({
  isAuthenticated: session.isAuthenticated,
});

const OfferNavConnected = connect(mapStateToProps)(withRouter(OfferNav));

export { OfferNavConnected as OfferNav, createFilterOptions, tabIsActive };



// WEBPACK FOOTER //
// ./src/components/Dashboard/OfferNav.js